<template>
  <div style="width:100%;box-sizing: border-box;">
    <div class='boxs'>
      <div class="seachBox">
        <div class="icons">
          <div class="greenDot"></div>
          <div class="dashedLine"></div>
          <div class="redDot"></div>
        </div>
        <div class="chooseCon">
          <div class="placeStation" @click='toSelect("入口")'>
            <div>
              <div class="places" v-show='ruObj.val'>{{ruObj.val}}</div>
              <div class="places gray" v-show='!ruObj.val'>点击搜索目的地站点（辽宁省内）</div>
            </div>
            <div class="stations gray">
              入口收费站&nbsp;&nbsp;&nbsp;<div style="color:#333333;width:1rem">{{ruStationObj.name}}</div>
              <!-- <div class="ruChange" style="background-color:#6EB6ED;color:#B2E5EF;" v-if='ruObj.val&&!chuObj.val'>更换</div>
              <div class="ruChange" @click="changeStation('入口',ruObj.val)" v-else-if='ruObj.val'>更换</div> -->
            </div>
          </div>
          <div class="placeStation" @click='toSelect("出口")'>
            <div >
              <div class="places" v-show='chuObj.val'>{{chuObj.val}}</div>
              <div class="places gray" v-show='!chuObj.val'>点击搜索目的地站点（辽宁省内）</div>
            </div>
            <div class="stations gray">
              出口收费站&nbsp;&nbsp;&nbsp;<div style="color:#333333;width:1rem">{{chuStationObj.name}}</div>
              <!-- <div class="ruChange" style="background-color:#6EB6ED;color:#B2E5EF;" v-if='chuObj.val&&!ruObj.val'>更换</div>
              <div class="ruChange" @click="changeStation('出口',chuObj.val)"  v-else-if='chuObj.val'>更换</div> -->
            </div>
          </div>
        </div>
        <div class="changewei" @click='changeWei'>
          <img src="../../assets/img/changewei.png" alt="">
        </div>
      </div>
    </div>
    <div class="stationChoose" v-show='ruStationList.length||chuStationList.length'>
      <div class="buttonCon">
        <div class="sureTo" @click="planRoad">规划路线</div>
        <div class="clearLo" @click="resetRoad">重置</div>
      </div>
      <div class="stationCon" v-show="stationText=='入口'">
        <div class="title">请选择入口收费站</div>
        <div class="stationList">
          <ul>
            <li v-for='(item,index) in ruStationList' :key='index'>
              <div>
                <div class="stationIcon">
                  <img :src="item.picurl" alt="">
                </div>
                <div style="width:85%;line-height: 1.7;">
                  <div class="titleStatus">
                    <div>
                      <span style="font-size:.15rem;font-weight:600;margin-right:.1rem;">{{item.name}}</span>
                      <span class="statusTip" style="background-color:#DBF5DD;color:#02864E;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode==2007000">正常</span>
                      <span class="statusTip" style="background-color:#DBF5DD;color:#02864E;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode==2007007">限制车型</span>
                      <span class="statusTip" style="background-color:#FFE4E2;color:#B20000;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode!=2007007&&item.controlcode!=2007000">封闭</span>
                    </div>
                    <div>
                      <img src="../../assets/img/dingwei.png" alt="" style="width:.12rem;height:.12rem;">
                      <span style="font-size:.12rem;">{{Number(item.distance)?(Number(item.distance)/1000):0}}km</span>
                    </div>
                  </div>
                  <div class="addressCon">
                    {{item.address}}
                  </div>
                </div>
              </div>
              <div>
                <div style="font-size:.12rem;color:#CD030A" v-show='!index'>
                  ！默认选择该收费站上高速
                </div>
                <div v-show='index'></div>
                <div class="choosed" v-show="item.flag">
                  <img src="../../assets/img/sureShe.png" alt="" style="width:.16rem;height:.16rem;    vertical-align: middle;">
                  <span>设为入口站</span>
                </div>
                <div class="unchoosed" v-show="!item.flag" @click="makeStation(index,item,ruStationList)">
                  <img src="../../assets/img/noShe.png" alt="" style="width:.16rem;height:.16rem;    vertical-align: middle;">
                  <span>设为入口站</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="stationCon" v-show="stationText=='出口'">
        <div class="title">请选择出口收费站</div>
        <div class="stationList">
          <ul>
            <li v-for='(item,index) in chuStationList' :key='index'>
              <div>
                <div class="stationIcon">
                  <img :src="item.picurl" alt="">
                </div>
                <div style="width:85%;line-height: 1.7;">
                  <div class="titleStatus">
                    <div>
                      <span style="font-size:.15rem;font-weight:600;margin-right:.1rem;">{{item.name}}</span>
                      <span class="statusTip" style="background-color:#DBF5DD;color:#02864E;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode==2007000">正常</span>
                      <span class="statusTip" style="background-color:#DBF5DD;color:#02864E;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode==2007007">限制车型</span>
                      <span class="statusTip" style="background-color:#FFE4E2;color:#B20000;border-radius:.08rem;font-size:.12rem;padding:.01rem .08rem;" v-show="item.controlcode!=2007007&&item.controlcode!=2007000">封闭</span>
                    </div>
                    <div>
                      <img src="../../assets/img/dingwei.png" alt="" style="width:.12rem;height:.12rem;">
                      <span style="font-size:.12rem;">{{Number(item.distance)?(Number(item.distance)/1000):0}}km</span>
                    </div>
                  </div>
                  <div class="addressCon">
                    {{item.address}}
                  </div>
                </div>
              </div>
              <div>
                <div style="font-size:.12rem;color:#CD030A" v-show='!index'>
                  ！默认选择该收费站上高速
                </div>
                <div v-show='index'></div>
                <div class="choosed" v-show="item.flag">
                  <img src="../../assets/img/sureShe.png" alt="" style="width:.16rem;height:.16rem;    vertical-align: middle;">
                  <span>设为出口站</span>
                </div>
                <div class="unchoosed" v-show="!item.flag" @click="makeStation(index,item,chuStationList)">
                  <img src="../../assets/img/noShe.png" alt="" style="width:.16rem;height:.16rem;    vertical-align: middle;">
                  <span>设为出口站</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stationText: "入口",
      ruStationObj: {},
      ruObj: {},
      chuStationObj: {},
      chuObj: {},
      lng: "",
      lat: "",
      useruuid: '',
      addName: this.$route.query.addName
        ? this.$route.query.addName
        : "我的位置",
      address: this.$route.query.address,
      concreteAdd: "",
      ruStationList: [],
      chuStationList: []
    };
  },
  mounted() {
    this.initFun();
    // if (window.history && window.history.pushState) {
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //   window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    // }
    if(this.$route.query.comeFrom) {
      sessionStorage.setItem('comeFrom',this.$route.query.comeFrom)
    }
  },
  destroyed() {
    // window.removeEventListener("popstate", this.backChange, false);
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == "/") {
        vm.lng = localStorage.getItem("mylongitude");
        vm.lat = localStorage.getItem("mylatitude");
        vm.address = localStorage.getItem("myAddress");
      } else {
        if (sessionStorage.getItem("stationText") == "入口") {
          if (JSON.parse(sessionStorage.getItem("chooseObj")).lng) {
            vm.lng = JSON.parse(sessionStorage.getItem("chooseObj")).lng
              ? JSON.parse(sessionStorage.getItem("chooseObj")).lng
              : JSON.parse(sessionStorage.getItem("ruObj")).lng;
            vm.lat = JSON.parse(sessionStorage.getItem("chooseObj")).lat
              ? JSON.parse(sessionStorage.getItem("chooseObj")).lat
              : JSON.parse(sessionStorage.getItem("ruObj")).lat;
            vm.addName = JSON.parse(sessionStorage.getItem("chooseObj")).addName
              ? JSON.parse(sessionStorage.getItem("chooseObj")).addName
              : JSON.parse(sessionStorage.getItem("ruObj")).val;
            vm.address = JSON.parse(sessionStorage.getItem("chooseObj")).address
              ? JSON.parse(sessionStorage.getItem("chooseObj")).address
              : JSON.parse(sessionStorage.getItem("ruObj")).address;
          } else if (
            sessionStorage.getItem("chuObj") &&
            JSON.parse(sessionStorage.getItem("chuObj")).lng
          ) {
            vm.lng = JSON.parse(sessionStorage.getItem("chuObj")).lng;
            vm.lat = JSON.parse(sessionStorage.getItem("chuObj")).lat;
            vm.addName = JSON.parse(sessionStorage.getItem("chuObj")).val;
            vm.address = JSON.parse(sessionStorage.getItem("chuObj")).address;
            sessionStorage.setItem("stationText", "出口");
          } else if (
            sessionStorage.getItem("ruObj") &&
            JSON.parse(sessionStorage.getItem("ruObj")).lng
          ) {
            vm.lng = JSON.parse(sessionStorage.getItem("ruObj")).lng;
            vm.lat = JSON.parse(sessionStorage.getItem("ruObj")).lat;
            vm.addName = JSON.parse(sessionStorage.getItem("ruObj")).val;
            vm.address = JSON.parse(sessionStorage.getItem("ruObj")).address;
          }
        } else {
          if (sessionStorage.getItem("stationText") == "出口") {
            if (JSON.parse(sessionStorage.getItem("chooseObj")).lng) {
              vm.lng = JSON.parse(sessionStorage.getItem("chooseObj")).lng
                ? JSON.parse(sessionStorage.getItem("chooseObj")).lng
                : JSON.parse(sessionStorage.getItem("chuObj")).lng;
              vm.lat = JSON.parse(sessionStorage.getItem("chooseObj")).lat
                ? JSON.parse(sessionStorage.getItem("chooseObj")).lat
                : JSON.parse(sessionStorage.getItem("chuObj")).lat;
              vm.addName = JSON.parse(sessionStorage.getItem("chooseObj"))
                .addName
                ? JSON.parse(sessionStorage.getItem("chooseObj")).addName
                : JSON.parse(sessionStorage.getItem("chuObj")).val;
              vm.address = JSON.parse(sessionStorage.getItem("chooseObj"))
                .address
                ? JSON.parse(sessionStorage.getItem("chooseObj")).address
                : JSON.parse(sessionStorage.getItem("chuObj")).address;
            } else if (
              sessionStorage.getItem("ruObj") &&
              JSON.parse(sessionStorage.getItem("ruObj")).lng
            ) {
              vm.lng = JSON.parse(sessionStorage.getItem("ruObj")).lng;
              vm.lat = JSON.parse(sessionStorage.getItem("ruObj")).lat;
              vm.addName = JSON.parse(sessionStorage.getItem("ruObj")).val;
              vm.address = JSON.parse(sessionStorage.getItem("ruObj")).address;
              sessionStorage.setItem("stationText", "入口");
            } else if (
              sessionStorage.getItem("chuObj") &&
              JSON.parse(sessionStorage.getItem("chuObj")).lng
            ) {
              vm.lng = JSON.parse(sessionStorage.getItem("chuObj")).lng;
              vm.lat = JSON.parse(sessionStorage.getItem("chuObj")).lat;
              vm.addName = JSON.parse(sessionStorage.getItem("chuObj")).val;
              vm.address = JSON.parse(sessionStorage.getItem("chuObj")).address;
            }
          }
        }
      }
      vm.initFun();
    });
  },
  methods: {
    backChange() {
      console.log('go to fastChoose')
      if(sessionStorage.getItem('comeFrom') == 1) {
        if (this.$route.params.browser.versions.weixin) {
          this.$router.push("/");
        } else if (this.$route.params.browser.versions.android) {
          window.liaoningactivity.bankSignResult("0", "5");
        } else {
          window.customServiceBack();
        }
      } else {
        sessionStorage.removeItem("ruObj");
        sessionStorage.removeItem("ruStationObj");
        sessionStorage.removeItem("ruStationList");
        sessionStorage.removeItem("stationText");
        sessionStorage.removeItem("chuObj");
        sessionStorage.removeItem("chuStationObj");
        sessionStorage.removeItem("chuStationList");
        sessionStorage.removeItem("chooseObj");

        this.$router.push("/");
      }
    },
    initFun() {
      this.stationText = sessionStorage.getItem("stationText")
        ? sessionStorage.getItem("stationText")
        : "入口";
      if (this.lng && this.lat) {
        this.getStation();
      }

      if (this.lng) {
        if (this.stationText == "入口") {
          this.ruObj = {
            val: this.addName ? this.addName : "",
            address: this.address ? this.address : "",
            lng: this.lng,
            lat: this.lat
          };
          sessionStorage.setItem("ruObj", JSON.stringify(this.ruObj));
        } else if (this.stationText == "出口") {
          this.chuObj = {
            val: this.addName ? this.addName : "",
            address: this.address ? this.address : "",
            lng: this.lng,
            lat: this.lat
          };
          sessionStorage.setItem("chuObj", JSON.stringify(this.chuObj));
        }
      }
      this.ruObj = JSON.parse(sessionStorage.getItem("ruObj"))
        ? JSON.parse(sessionStorage.getItem("ruObj"))
        : {};
      this.chuObj = JSON.parse(sessionStorage.getItem("chuObj"))
        ? JSON.parse(sessionStorage.getItem("chuObj"))
        : {};
      this.ruStationObj = JSON.parse(sessionStorage.getItem("ruStationObj"))
        ? JSON.parse(sessionStorage.getItem("ruStationObj"))
        : {};
      this.chuStationObj = JSON.parse(sessionStorage.getItem("chuStationObj"))
        ? JSON.parse(sessionStorage.getItem("chuStationObj"))
        : {};
    },
    getStation() {
      this.$Post(
        "highwayInfoSVGWeb/fetchStationByCoor",
        {
          address: this.address,
          name: this.addName,
          coor_x: this.lng,
          coor_y: this.lat,
          useruuid: this.useruuid
        },
        ({ data }) => {
          if (this.stationText == "入口") {
            this.ruStationList = data;
            this.ruStationList.forEach((item, index) => {
              if (index) {
                this.$set(item, "flag", false);
              } else {
                this.$set(item, "flag", true);
              }
            });
            this.ruStationObj = this.ruStationList[0];
            sessionStorage.setItem(
              "ruStationObj",
              JSON.stringify(this.ruStationObj)
            );
            sessionStorage.setItem("ruStationList", JSON.stringify(data));
          } else {
            this.chuStationList = data;
            this.chuStationList.forEach((item, index) => {
              if (index) {
                this.$set(item, "flag", false);
              } else {
                this.$set(item, "flag", true);
              }
            });
            this.chuStationObj = this.chuStationList[0];
            sessionStorage.setItem(
              "chuStationObj",
              JSON.stringify(this.chuStationObj)
            );
            sessionStorage.setItem(
              "chuStationList",
              JSON.stringify(this.chuStationList)
            );
          }
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    changeStation(val) {
      this.stationText = val;
      sessionStorage.setItem("stationText", val);
      let obj = {};
      if (val == "入口") {
        obj = {
          address: this.ruObj.address,
          name: this.ruObj.val,
          coor_x: this.ruObj.lng,
          coor_y: this.ruObj.lat,
          useruuid: this.useruuid
        };
      } else {
        obj = {
          address: this.chuObj.address,
          name: this.chuObj.val,
          coor_x: this.chuObj.lng,
          coor_y: this.chuObj.lat,
          useruuid: this.useruuid
        };
      }
      this.$Post(
        "highwayInfoSVGWeb/fetchStationByCoor",
        obj,
        ({ data }) => {
          if (this.stationText == "入口") {
            this.ruStationList = data;
            this.ruStationList.forEach((item, index) => {
              if (index) {
                this.$set(item, "flag", false);
              } else {
                this.$set(item, "flag", true);
              }
            });
            this.ruStationObj = this.ruStationList[0];
            sessionStorage.setItem(
              "ruStationObj",
              JSON.stringify(this.ruStationObj)
            );
            sessionStorage.setItem("ruStationList", JSON.stringify(data));
          } else {
            this.chuStationList = data;
            this.chuStationList.forEach((item, index) => {
              if (index) {
                this.$set(item, "flag", false);
              } else {
                this.$set(item, "flag", true);
              }
            });
            this.chuStationObj = this.chuStationList[0];
            sessionStorage.setItem(
              "chuStationObj",
              JSON.stringify(this.chuStationObj)
            );
            sessionStorage.setItem("chuStationList", JSON.stringify(data));
          }
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    makeStation(ind, obj, arr) {
      arr.forEach((item, index) => {
        if (index != ind) {
          this.$set(item, "flag", false);
        } else {
          this.$set(item, "flag", true);
        }
      });
      if (this.stationText == "入口") {
        this.ruStationObj = obj;
        sessionStorage.setItem(
          "ruStationObj",
          JSON.stringify(this.ruStationObj)
        );
      } else {
        this.chuStationObj = obj;
        sessionStorage.setItem(
          "chuStationObj",
          JSON.stringify(this.chuStationObj)
        );
      }
    },
    changeWei() {
      // 存值
      let ruToChuObj = this.ruObj;
      let chuToRuObj = this.chuObj;
      let ruToChuStationObj = this.ruStationObj;
      let chuToRuStationObj = this.chuStationObj;
      let ruToChuList = JSON.parse(sessionStorage.getItem("ruStationList"))
        ? JSON.parse(sessionStorage.getItem("ruStationList"))
        : [];
      let chuToRuList = JSON.parse(sessionStorage.getItem("chuStationList"))
        ? JSON.parse(sessionStorage.getItem("chuStationList"))
        : [];
      // 取值
      this.ruObj = chuToRuObj;
      this.chuObj = ruToChuObj;
      this.ruStationObj = chuToRuStationObj;
      this.chuStationObj = ruToChuStationObj;
      this.ruStationList = chuToRuList;
      this.chuStationList = ruToChuList;
      if (this.ruObj.val && this.chuObj.val) {
        sessionStorage.setItem("stationText", "入口");
      } else if (this.ruObj.val) {
        sessionStorage.setItem("stationText", "入口");
      } else if (this.chuObj.val) {
        sessionStorage.setItem("stationText", "出口");
      }
      this.stationText = sessionStorage.getItem("stationText");
      // 保留
      sessionStorage.setItem("ruObj", JSON.stringify(this.ruObj));
      sessionStorage.setItem("chuObj", JSON.stringify(this.chuObj));
      sessionStorage.setItem("ruStationObj", JSON.stringify(this.ruStationObj));
      sessionStorage.setItem(
        "chuStationObj",
        JSON.stringify(this.chuStationObj)
      );
      sessionStorage.setItem(
        "ruStationList",
        JSON.stringify(this.ruStationList)
      );
      sessionStorage.setItem(
        "chuStationList",
        JSON.stringify(this.chuStationList)
      );
    },
    toSelect(text) {
      sessionStorage.setItem("stationText", text);
      sessionStorage.setItem("chooseObj", JSON.stringify({}));
      this.$router.replace(`/chooseLoc`);
    },
    planRoad() {
      if (!this.ruStationObj.name) {
        this.$alertShow("请选择入口收费站");
        return;
      }
      if (!this.chuStationObj.name) {
        this.$alertShow("请选择出口收费站");
        return;
      }
      if (this.ruStationObj.stationcode == this.chuStationObj.stationcode) {
        this.$alertShow("起点与终点不能相同");
        return;
      }
      this.$router.push(
        `/planRoad?instationcode=${this.ruStationObj.stationcode}&&outstationcode=${this.chuStationObj.stationcode}&comeFrom=${this.$route.query.comeFrom}`
      );
    },
    resetRoad() {
      this.ruStationObj = {};
      this.ruObj = {};
      this.chuStationObj = {};
      this.chuObj = {};
      this.ruStationList = [];
      this.chuStationList = [];
      sessionStorage.setItem("ruStationObj", JSON.stringify(this.ruStationObj));
      sessionStorage.setItem(
        "chuStationObj",
        JSON.stringify(this.chuStationObj)
      );
      sessionStorage.setItem("ruObj", JSON.stringify(this.ruObj));
      sessionStorage.setItem("chuObj", JSON.stringify(this.chuObj));
      sessionStorage.setItem("ruStationList", JSON.stringify([]));
      sessionStorage.setItem("chuStationList", JSON.stringify([]));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.boxs {
  box-sizing: border-box;
  padding: .2rem .1rem;
  box-shadow: 0px .02rem .05rem 0px #ccc;
  .seachBox {
    display: flex;
    justify-content: space-between;
    // width: 354px;
    margin: auto;
    background-color: #f5f5f5;
    padding: .09rem;
    border-radius: .04rem;
    .icons {
      width: 10%;
      margin-top: .09rem;
      .greenDot,
      .redDot {
        width: .09rem;
        height: .09rem;
        border-radius: .04rem;
      }
      .greenDot {
        background-color: #36cb39;
      }
      .redDot {
        background-color: #f93a3a;
      }
      .dashedLine {
        border-right: .01rem dashed #b9b8b8;
        height: .64rem;
        width: .01rem;
        margin-left: .025rem;
      }
    }
    .chooseCon {
      width: 80%;
      margin-top: .02rem;
      .placeStation {
        height: .7rem;
        .stations {
          font-size: .12rem;
          margin-top: .12rem;
          display: flex;
          align-items: center;
          .ruChange {
            // margin-left: 60px;
            background-color: #38abf5;
            color: #fff;
            padding: .04rem .08rem;
            font-size: .12rem;
            border-radius: .03rem;
          }
        }
      }
    }
    .changewei {
      width: 10%;
      margin-top: .5rem;
      img {
        width: .24rem;
        height: .24rem;
      }
    }
  }
}
.gray {
  color: #b9b8b8;
}
.stationChoose {
  margin-top: .16rem;
  padding: .1rem;
  width: 100%;
  box-sizing: border-box;
  .buttonCon {
    display: flex;
    margin-bottom: .26rem;
    justify-content: center;
    > div {
      padding: .06rem .2rem .03rem;
      margin: 0 .1rem;
      border-radius: .03rem;
      font-size: .15rem;
    }
    .sureTo {
      background-color: #38abf5;
      color: #fff;
    }
    .clearLo {
      border: .01rem solid #b9b8b8;
      color: #b9b8b8;
    }
  }
  .stationCon {
    .title {
      font-size: .18rem;
      font-weight: 600;
    }
    .stationList {
      ul {
        li {
          padding: .11rem 0;
          border-bottom: .01rem solid #f0efef;
          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .stationIcon {
              width: .6rem;
              text-align: center;
              img {
                width: .5rem;
                height: .5rem;
              }
            }
            .titleStatus {
              display: flex;
              justify-content: space-between;
            }
            .addressCon {
              font-size: .12rem;
            }
            .choosed {
              color: #b9b8b8;
              border: .01rem solid rgba(235, 235, 235, 1);
              font-size: .12rem;
              padding: .01rem;
              border-radius: .02rem;
            }
            .unchoosed {
              color: #000000;
              border: .01rem solid #000000;
              font-size: .12rem;
              padding: .01rem;
              border-radius: .02rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/fastChoose/index.vue